import Vue from 'vue'
import Axios from 'axios'
import Buefy from 'buefy'
import i18n from '@/i18n'
import IdleVue from 'idle-vue'
import VueKeycloakJs from '@dsb-norge/vue-keycloak-js'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import '@mdi/font/css/materialdesignicons.css'

import '@/registerServiceWorker'

import VModal from 'vue-js-modal'
import getEnv from '@/store/env'

Vue.prototype.$http = Axios

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

const eventsHub = new Vue()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 900000, // In milliseconds, 15 minutes
  startAtIdle: false
})

Vue.use(Buefy)

Vue.config.productionTip = false

let kpref = parseInt(localStorage.getItem('kpref'))
let keycloakUrl = getEnv('VUE_APP_KEYCLOAK_URL')
let keycloakRealm = getEnv('VUE_APP_KEYCLOAK_REALM')
let keycloakClientId = getEnv('VUE_APP_KEYCLOAK_CLIENT_ID')

if (kpref === 2) {
  keycloakUrl = getEnv('VUE_APP_KEYCLOAK2_URL')
  keycloakRealm = getEnv('VUE_APP_KEYCLOAK2_REALM')
  keycloakClientId = getEnv('VUE_APP_KEYCLOAK2_CLIENT_ID')
}

Vue.use(VueKeycloakJs, {
  config: {
    url: keycloakUrl,
    realm: keycloakRealm,
    clientId: keycloakClientId
  },
  init: {
    onLoad: 'check-sso',
    checkLoginIframe: false
  },
  onReady: (keycloak) => {
    new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
    let klogin = parseInt(localStorage.getItem('klogin'))
    if (klogin === 1) {
      localStorage.setItem('klogin', 0)
      keycloak.login()
    }
  }
})

Vue.use(VModal, { dialog: true })
